<template>
  <BaseDialog
    ref="baseDialog"
    :modal-id="`delete${entityName}Dialog`"
    :title="computedTitle"
    :confirm-text="$t('deleteDialog.confirm')"
    confirm-variant="danger"
    :loading="loading"
    @confirm="handleConfirm"
  >
    <template #body>
      <p v-html="computedMessage"></p>
      <p class="text-danger">{{ $t('deleteDialog.warning') }}</p>
      <p v-if="softDelete" class="text-warning">{{ $t('deleteDialog.softDeleteWarning') }}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseDialog from '@/components/common/BaseDialog.vue';

const { t } = useI18n();

const props = defineProps({
  entityName: { type: String, required: true },
  entityLabel: { type: String, default: '' },
  title: { type: String, default: '' },
  softDelete: { type: Boolean, default: false }
});

const emit = defineEmits(['delete']);

const baseDialog = ref(null);
const loading = ref(false);
const entityDisplayName = ref('');
const entityId = ref(null);

const computedTitle = computed(() => {
  if (props.title) return props.title;
  return t('deleteDialog.title', { entity: props.entityLabel });
});

const computedMessage = computed(() => {
  return t('deleteDialog.message', { 
    entity: props.entityLabel, 
    name: entityDisplayName.value 
  });
});

const openDialog = (id, displayName) => {
  entityId.value = id;
  entityDisplayName.value = displayName;
  baseDialog.value.openDialog();
};

const closeDialog = () => {
  baseDialog.value.closeDialog();
};

const handleConfirm = async () => {
  loading.value = true;
  try {
    await emit('delete', entityId.value);
    closeDialog();
  } catch (error) {
    // Error handling is done in the parent
  } finally {
    loading.value = false;
  }
};

defineExpose({ openDialog, closeDialog });
</script>